import axios from "axios";
import { config } from "../../../../enviroment";
import {apolloClientService} from '../../../../services/apollo-client';

export const tipService = {
    getTips
}

async function getTips(customerClassCode,languageCode) {
    
    const ApiQuery=`{getTips(input:{
        tenantCode:"`+config.constants.BASE_TENANT_CODE+`",
        customerClassCode:"`+customerClassCode+`"
        languageCode:"`+languageCode+`"
    }){
        tipsDetails{
            tipId
           
            tipTitle
            tipShortDescription
            tipLongDescription
            tipSequence
            
            tipIconName
            tipCriteriaParameter
            tipTenantCode         
        }
    }}`
    return await apolloClientService.ApolloClientgqlsCommunication(ApiQuery);
  }